import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'i18next'
import { useCommonState } from '@/core/context/useContext'
import iconsSprite from '@/assets/icons.svg'
import * as S from './styled'

export default function MHistory() {
  const { isLogin } = useCommonState()
  const navigate = useNavigate()

  useEffect(() => {
    const el = document.getElementById('m-history')
    if (!el) return
    const onScroll = () => el.classList.toggle('show', window.scrollY > 200)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [isLogin])

  if (!isLogin) return null

  return (
    <S.HistoryBtn
      id="m-history"
      onClick={() => navigate('/bet-history')}
    >
      <div>
        <span className="icon icon-color-y icon--xxl">
          <svg viewBox="0 0 41 39" focusable="false"><use href={`${iconsSprite}#ico-card1`} /></svg>
        </span>
        <span className="font-serif-en">{t('footer.historyTitle')}</span>
      </div>
    </S.HistoryBtn>
  )
}
